import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import { ICommandBase } from '@Quest/cqrs';
import { DeletePnlCommandV1 } from '@Quest/Pnls/Domain/commands-core';
import PnlsCommands from '@Quest/Pnls/Domain/commands-vue-component';
import PnlsQueries from '@Quest/Pnls/Domain/queries-vue-component';
import { PnlsPageReadModel } from '@Quest/Pnls/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component({ components: { CorporateNavigation } })
export default class PnlsPage extends mixins(PnlsCommands, PnlsQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: PnlsPageReadModel | null = null;

    mounted()
    {
        document.title = "P&L templates | TransparentChoice";
        this.runPnlsPageQueryV1(this.workspaceId, this.strategyId);
    }

    handleDeletePnlCommand(pnlId: string)
    {
        if (confirm("Are you sure?") === true)
        {
            this.invokeDeletePnlCommandV1(this.workspaceId, this.strategyId, pnlId);
        }
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName === "PnlsPageReadModel")
        {
            this.rm = model as PnlsPageReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (DeletePnlCommandV1.matchType(cmd))
        {
            this.rm!.Corporate = this.rm!.Corporate.filter(a => a.Id !== correlationId);
        }
    }
}
